import format from 'date-fns/format';
import { generateTrendAnalysisYAxisMin } from 'utils/charts/chart';
import { noResultsText } from 'utils/charts/constants';

export const teamTrendAnalysisChartOptions = (data) => {
    const validData = data
        ? data.filter((d) => d.month > 0 && d.year > 0 && d.score).reverse()
        : [];
    const dateList = validData.map((d) =>
        format(new Date(d.year, d.month - 1, 1), 'MMM-yy')
    );
    const scoreList = validData.map((d) => d.score);

    return {
        title: {
            left: 'left',
            text: 'Trend Analysis',
            textStyle: {
                color: '#244B60',
                fontSize: '12px'
            }
        },
        xAxis: [
            {
                data: dateList,
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    show: true,
                    padding: [16, 0, 0, 0]
                }
            }
        ],
        yAxis: [
            {
                name: 'Normalized Risk Score',
                nameLocation: 'center',
                nameTextStyle: {
                    color: '#7FADBF',
                    fontWeight: 600,
                    fontSize: 12
                },
                nameGap: 30,
                axisLabel: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                min: generateTrendAnalysisYAxisMin(scoreList)
            }
        ],
        series: [
            {
                type: 'line',
                symbolSize: [7, 7],
                data: scoreList,
                lineStyle: {
                    color: '#929292'
                },
                itemStyle: {
                    color: '#929292'
                },
                label: {
                    show: true,
                    position: 'top',
                    fontSize: 10,
                    fontWeight: 700,
                    lineheight: 14,
                    offset: [0, -4]
                },
                boundaryGap: false,
                cursor: 'default'
            }
        ],
        grid: {
            width: '420px',
            height: '60%',
            top: '20%',
            left: '50px'
        },
        graphic: !dateList || dateList.length === 0 ? [noResultsText] : []
    };
};
